import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useSendNavigationToGoogleAnalyticsEffect } from '~/tracking/googleAnalytics';
import { isDebugLogEnabled } from './logger';
import { getLogger } from '~/logging/logger.ts';

const log = getLogger('client-side-route-tracker');

export function ClientSideRouteTracker() {
  // 2025-02-17, jonas: Das eigentliche Ziel is es die Logik des Hooks nur Client-Side aufzurufen.
  // Technisch gesehen dürfte der Hook auch während dem SSR aufgerufen werden,
  // aber das wäre unnötiger Overhead, da der Hook nur Client-Side relevant ist.
  // Wegen den "Rules of Hooks" gibt es aber meines Wissens keine saubere Lösung,
  // die Logik in einem Hook nur Client-Side aufzurufen, daher wrappe ich den Hook-Aufruf
  // in einer Komponente, die nur Client-Side gerendert wird ...
  useClientSideRouteTracking();
  useSendNavigationToGoogleAnalyticsEffect();
  return null;
}

function useClientSideRouteTracking() {
  const initialPageLoad = useRef(true);
  const location = useLocation();

  useEffect(() => {
    if (isDebugLogEnabled()) {
      if (initialPageLoad.current) {
        log.debug(`TRACKING: Initial load of route ${window.location.href}`);
      } else {
        log.debug(`TRACKING: Navigated to route ${window.location.href}`);
      }
    }

    if (initialPageLoad.current) {
      initialPageLoad.current = false;
    }
  }, [location]);
}
